import { get } from '../utility/http';
import { REACT_APP_URL_COMUNI, REACT_APP_URL_REGIONI, REACT_APP_URL_PROVINCE } from './../config';

export async function fetchRegioni(): Promise<any> {
  try {
    const response = await get(`${REACT_APP_URL_REGIONI}`, true, {});
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchProvince(regione: string): Promise<any> {
  try {
    const response = await get(`${REACT_APP_URL_PROVINCE}?filter=regione eq ${regione}`, true, {});
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchComuni(provincia: string): Promise<any> {
  try {
    const response = await get(
      `${REACT_APP_URL_COMUNI}?filter=provincia eq ${provincia}&$size=10000`,
      true,
      {}
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchBoundComune(comune: string): Promise<any> {
  try {
    const response = await get(
      `${REACT_APP_URL_COMUNI}?include=extent&srid=4326&filter=comune eq ${comune}`,
      true,
      {}
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}

export async function fetchContainerTasks(ctx: string): Promise<any> {
  try {
    const response = await get(
      `/tasks/tasks/ctx/${ctx}?type=drone-mission&projection=EPSG:3857`,
      true
    );
    return response;
  } catch (e: any) {
    return Promise.reject(e.response ? e.response : e);
  }
}
